import styled from 'styled-components';

export const AvisosContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	margin-bottom: 2rem;
	background: #fff8f0;
	border: 1px solid #f5e6d3;
	border-radius: 8px;
	padding: 1rem 1.25rem;
`;

export const Avis = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	gap: 0.5rem;
`;

export const ActionButton = styled.button`
	padding: 0.25rem 0.6rem;
	border: 1px solid #ddd;
	border-radius: 4px;
	background: white;
	font-size: 0.8rem;
	cursor: pointer;
`;
